import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';

import { Text } from '../Text';
import Link from '../Link';

export const StyledParagraph = styled(Text)`
  white-space: pre-wrap;
  word-break: break-word;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
`;

export const StyledAnchor = styled(Link)`
  color: ${({ theme }) => theme.color.inlineAnchor};
  font-weight: ${({ theme }) => theme.fontWeight.inlineAnchor};
  text-decoration: underline;
  transition: 0.2s color ease;

  &:hover {
    color: ${({ theme }) => theme.color.inlineAnchorHover};
  }
`;

export const StyledHorizontalRule = styled('hr')`
  border-top: 1px solid ${({ theme }) => theme.color.black};
  width: 100%;
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export const StyledOrderedList = styled('ol')`
  font-size: ${({ theme }) => theme.fontSize.p_0};
  line-height: ${({ theme }) => theme.lineHeight.p_0};
  margin: ${({ theme }) => theme.spacing.m} 0;

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.p_desktop};
    line-height: ${({ theme }) => theme.lineHeight.p_desktop};
  }
`;

export const StyledUnorderedList = styled('ul')`
  font-size: ${({ theme }) => theme.fontSize.p_0};
  line-height: ${({ theme }) => theme.lineHeight.p_0};
  margin: ${({ theme }) => theme.spacing.m} 0;
  list-style-type: unset;
  padding-inline-start: 40px;

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.p_desktop};
    line-height: ${({ theme }) => theme.lineHeight.p_desktop};
  }
`;

export const StyledListItem = styled('li')`
  margin: ${({ theme }) => theme.spacing.s} 0;
  padding-left: ${({ theme }) => theme.spacing.s};
`;
